import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=abb9de30&scoped=true"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"
import style0 from "./Info.vue?vue&type=style&index=0&id=abb9de30&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb9de30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abb9de30')) {
      api.createRecord('abb9de30', component.options)
    } else {
      api.reload('abb9de30', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=abb9de30&scoped=true", function () {
      api.rerender('abb9de30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Info.vue"
export default component.exports